import { Row, Col, Breadcrumb } from "react-bootstrap";
import { IThirdPartyCorrespondenceDetails } from "../../../api/IThirdPartyCorrespondence";
import { ILicenceProfile } from "../../../api/ILicenceProfile";

interface BreadcrumbProps {
  licenceProfile: ILicenceProfile;
  thirdPartyCorrespondence: IThirdPartyCorrespondenceDetails;
}

const BreadCrumbs = ({
  licenceProfile,
  thirdPartyCorrespondence,
}: BreadcrumbProps) => (
  <Row>
    <Col xs="12">
      <Breadcrumb className="leap">
        <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`/licence-profile/${licenceProfile.profileNo}`}>
          {licenceProfile.organisation} - {licenceProfile.profileNo}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/compliance`}
        >
          Compliance
        </Breadcrumb.Item>
        <Breadcrumb.Item active>
          {thirdPartyCorrespondence.reference}
        </Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  </Row>
);

export default BreadCrumbs;
